module.exports = __webpack_public_path__ + "static/media/pin.c3823a77.svg";